// extracted by mini-css-extract-plugin
export default {"reliability_card_container":"reliability_card_container___UoDDE","reliability_card":"reliability_card___EE66y"};